export default __webpack_public_path__ + "static/pixel-duck-5353f54a0de185c77cb8ad83cbc56873.png";